/* Lazy load secondary images for product cards (mobile: on viewport; desktop: also on hover) */
(() => {
  function initLazySecondaryImages() {
    try {
      var cards = document.querySelectorAll('a.product-card__media[data-secondary-srcset]');
      if (!cards.length) return;
      if (!('IntersectionObserver' in window)) {
        cards.forEach(loadSecondaryImage);
        return;
      }
      var io = new IntersectionObserver(function(entries) {
        entries.forEach(function(entry) {
          if (entry.isIntersecting) {
            loadSecondaryImage(entry.target);
            io.unobserve(entry.target);
          }
        });
      }, { rootMargin: '200px' });
      cards.forEach(function(card) { io.observe(card); });
      document.addEventListener('mouseover', function(e) {
        var el = e.target.closest && e.target.closest('a.product-card__media[data-secondary-srcset]');
        if (el) { loadSecondaryImage(el); }
      }, { passive: true });
    } catch (err) { /* no-op */ }
  }

  function loadSecondaryImage(anchor) {
    if (!anchor || anchor.__secondaryLoaded) return;
    var srcset = anchor.getAttribute('data-secondary-srcset');
    if (!srcset) return;
    var sizes = anchor.getAttribute('data-secondary-sizes') || '(max-width: 699px) 100vw, 400px';
    var width = anchor.getAttribute('data-secondary-width');
    var height = anchor.getAttribute('data-secondary-height');
    var img = document.createElement('img');
    img.className = 'product-card__image product-card__image--secondary';
    img.setAttribute('decoding', 'async');
    img.setAttribute('loading', 'lazy');
    img.setAttribute('fetchpriority', 'low');
    if (width) img.setAttribute('width', width);
    if (height) img.setAttribute('height', height);
    img.setAttribute('srcset', srcset);
    img.setAttribute('sizes', sizes);
    var container = anchor.querySelector('.product-card__media-scroll');
    if (container) {
      container.appendChild(img);
      anchor.__secondaryLoaded = true;
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initLazySecondaryImages);
  } else {
    initLazySecondaryImages();
  }
})();


